import React from 'react';
import { motion } from 'framer-motion';

const HRHighlight = ({ homeRuns, awayAbbr, homeAbbr, onPlayerClick }) => {
  if (!homeRuns.length) return (
    <div className="text-[#658d71] text-xs text-center py-6 uppercase tracking-widest">
      No home runs yet
    </div>
  );

  return (
    <div className="flex flex-col gap-2">
      {homeRuns.map((hr, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, scale: 0.97 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: i * 0.05 }}
          className="border border-[#c4333e] bg-[rgba(196,51,62,0.08)] p-3 flex flex-col gap-2"
        >
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-[9px] bg-[#c4333e] text-white px-2 py-0.5 font-black uppercase tracking-widest">
              💣 Home Run
            </span>
            <span className="text-[9px] text-[#658d71] font-bold uppercase tracking-widest">
              {hr.isTop ? '▲' : '▼'}{hr.inning} · {hr.isTop ? awayAbbr : homeAbbr}
            </span>
            {hr.rbi > 0 && (
              <span className="text-[9px] bg-[rgba(196,51,62,0.3)] text-[#e6a8a8] border border-[rgba(196,51,62,0.5)] px-1.5 py-0.5 font-black">
                {hr.rbi} RBI
              </span>
            )}
            <span className="ml-auto text-[9px] text-[#658d71] tabular-nums font-bold">
              {hr.awayScore}–{hr.homeScore}
            </span>
          </div>

          <button
            onClick={() => hr.batterId && onPlayerClick?.(hr.batterId, hr.batter)}
            className="text-left group"
          >
            <span className="text-sm font-black uppercase tracking-wide text-white group-hover:text-[#d8ceb3] transition-colors">
              {hr.batter}
            </span>
            <span className="ml-2 text-[9px] text-[#658d71] group-hover:text-[#a9c9b1] transition-colors font-bold">
              View Profile →
            </span>
          </button>

          {(hr.exitVelocity || hr.distance || hr.launchAngle) && (
            <div className="flex gap-3 flex-wrap border-t border-[rgba(196,51,62,0.25)] pt-2">
              {hr.exitVelocity && (
                <div className="flex flex-col items-center border border-[rgba(196,51,62,0.4)] px-2 py-1 bg-[rgba(0,0,0,0.1)]">
                  <span className="text-[8px] text-[#658d71] uppercase tracking-widest font-bold">Exit Velo</span>
                  <span className="text-sm font-black text-[#c4333e] tabular-nums">{Math.round(hr.exitVelocity)} mph</span>
                </div>
              )}
              {hr.launchAngle && (
                <div className="flex flex-col items-center border border-[rgba(196,51,62,0.4)] px-2 py-1 bg-[rgba(0,0,0,0.1)]">
                  <span className="text-[8px] text-[#658d71] uppercase tracking-widest font-bold">Launch Angle</span>
                  <span className="text-sm font-black text-[#d8ceb3] tabular-nums">{Math.round(hr.launchAngle)}°</span>
                </div>
              )}
              {hr.distance && (
                <div className="flex flex-col items-center border border-[rgba(196,51,62,0.4)] px-2 py-1 bg-[rgba(0,0,0,0.1)]">
                  <span className="text-[8px] text-[#658d71] uppercase tracking-widest font-bold">Distance</span>
                  <span className="text-sm font-black text-[#a9c9b1] tabular-nums">{Math.round(hr.distance)} ft</span>
                </div>
              )}
            </div>
          )}

          <p className="text-[9px] text-[#658d71] leading-snug line-clamp-2">{hr.description}</p>
        </motion.div>
      ))}
    </div>
  );
};

export default HRHighlight;